<template>
  <section v-if="form">
    <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;overflow:hidden;">

      <el-form-item label="出库单号:">
        {{form.number}}
      </el-form-item>
      <el-form-item label="所属仓库:">
        <!-- {{from.outHouse.name}} -->
        <router-link class="link" target="_blank" :to="'/Storage/Detail/'+form.houseId">
          {{form.houseName}}
        </router-link>
      </el-form-item>
      <el-form-item label="客户名称:" v-if="form.customer">
        {{form.customer}}
      </el-form-item>
      <el-form-item label="所属工程:" v-if="form.projectName">
        <router-link class="link" target="_blank" :to="'/Project/Detail/'+form.projectId">
          {{form.projectName}}
        </router-link>
      </el-form-item>
      <el-form-item label="材料申请人:">
        <user-info :userData='form.creator'></user-info>
      </el-form-item>
      <el-form-item label="申请时间:">
        {{ getTime(form.flow.createTime) }}
      </el-form-item>
      <!-- <el-form-item label="总金额(元):">
        {{total}}
      </el-form-item> -->
      <el-form-item class="full" label="材料明细:">
        <div class="material-table">
          <el-table :data="form.materialUse" border>
            <el-table-column prop="number" label="材料编号">
            </el-table-column>
            <el-table-column prop="name" label="明细名称" width="240">
            </el-table-column>
            <el-table-column prop="dlName" label="材料类别" width="200">
            </el-table-column>
            <el-table-column prop="" align="center" label="数量">
              <template slot-scope="scope">
                {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="unitName" align="center" label="计量单位">
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
    </el-form>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {
      total: function () {
        var _total = 0
        for (var i = 0; i < this.form.materialUse.length; i++) {
          var _item = this.form.materialUse[i]
          _total += _item.totalPrice / 1
        }
        return _total
      }
    },
    props: ['form', 'flowUser'],
    data() {
      return {
        // total: ''  
      }
    },
    methods: {
      getTime(t) {
        return util.getFormatDate(t, true)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/components/materialUseDetail.vue